import { atom } from 'jotai'
import type { CheckoutStep, TReferralInfo, TThailandCheckoutForm, TAddressHistoryItem, TThailandShippingForm } from './checkout.types'

export const checkoutStepAtom = atom<CheckoutStep>('form')
export const checkoutReferralIdAtom = atom<string>('')
export const checkoutReferralInfoAtom = atom<TReferralInfo | null>(null)
export const checkoutUuidAtom = atom<string>('')
export const checkoutPeriodAtom = atom<string>('')
export const checkoutLoadingAtom = atom<boolean>(false)
export const checkoutErrorsAtom = atom<string[]>([])

export const checkoutSignupFormAtom = atom<TThailandCheckoutForm | null>(null)
export const checkoutSelectedAddressAtom = atom<TAddressHistoryItem | null>(null)
export const checkoutShippingFormAtom = atom<TThailandShippingForm | null>(null)
